export default "__VITE_ASSET__BxEhwhoY__"